
import {useState, useEffect} from "react";
import styles from "./round-button.module.css";
import InfoPopup from "./InfoPopup";

export default function ToggleLightDarkMode () {

    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem("theme");
        if (saved) return saved;
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";}
    );

    useEffect(() => {
        // Update body class
        document.body.classList.remove("light-theme", "dark-theme");
        document.body.classList.add(`${theme}-theme`);

        // Persist theme
        localStorage.setItem("theme", theme);

        // Update meta theme-color
        const metaThemeColor = document.querySelector("meta[name=theme-color]");
        const styles = getComputedStyle(document.body); // or document.documentElement
        const color = styles.getPropertyValue('--secondary-color').trim();
        if (metaThemeColor) { metaThemeColor.setAttribute("content", color); }
    }, [theme]);

    const toggleTheme = () => setTheme((prev) => (prev === "light" ? "dark" : "light"));

    return (
            <InfoPopup info={theme === "dark" ? "Light mode?" : "Dark mode?"}>
                <div onClick={toggleTheme} className={styles.toggleButton}>
                    {theme === "dark" 
                        ? < img src="./images/light.png" className={styles.toggleImage} alt="switch to light mode button" /> 
                        : < img src="./images/dark.png" className={styles.toggleImage} alt="switch to dark mode button" />}
                </div>
            </InfoPopup>
    );
    
}